import 'angular:locale/data:en-US';
import './src/polyfills.ts';
import 'es-module-shims';(globalThis.$localize ??= {}).locale = "en-US";
